import React from 'react';
import { NotificationBadge, NotificationBadgeVariant } from '@patternfly/react-core';
import { useNotifications } from '../../contexts/NotificationContext';

function GlobalNotificationBadge() {
  const { notifications, setDrawerOpen, isDrawerOpen } = useNotifications();

  const unreadCount = notifications.filter((n) => !n.isNotificationRead).length;
  const hasUnreadDanger = notifications.some((n) => !n.isNotificationRead && n.variant === 'danger');

  const getVariant = () => {
    if (unreadCount === 0) return NotificationBadgeVariant.read;
    if (hasUnreadDanger) return NotificationBadgeVariant.attention;
    return NotificationBadgeVariant.unread;
  };

  return (
    <NotificationBadge
      variant={getVariant()} // Changed from hardcoded NotificationBadgeVariant.read
      onClick={() => setDrawerOpen(!isDrawerOpen)}
      aria-label="Notifications"
      count={unreadCount}
    />
  );
}

export { GlobalNotificationBadge };
